import { EventData, VdpEventData } from 'lib/EventLogger/Event';
import { EventType, SourcePages, ViewTypes } from 'lib/EventSchema';
import { VehicleEventInfo } from 'lib/Tracking/types';

const event = ({ trackingParams }: VehicleEventInfo): EventData & VdpEventData => {
  return {
    event_type: EventType.view,
    source_page: SourcePages.Vdp,
    view_type: ViewTypes.modalClose,
    event_context: {
      modal_name: 'photo_slide_show',
      tracking_params: trackingParams,
    },
  };
};

export default event;
